import Base from "@/api-services/base";
const BaseURL = `Solicitudes`;

export default {
  GetsResponse: null,
  Listado: [],
  FotoURL(Registro) {
    return "/img/grupos.svg";
  },
  gets(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsColaboradorPrevio(
    Vista,
    BaseGetsListado,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Colaboradores/Previo`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsEnriquecido(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Enriquecido`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsTotales(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    console.debug("GetsTotales");
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Totales`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsAgrupadas(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Agrupadas`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  getsSelect(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    if (this.GetsResponse != null) OnCorrecto(this.GetsResponse);
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      { PaginaLen: 1000 },
      (response) => {
        this.GetsResponse = response;
        this.Listado = response.data.listado;
        if (OnCorrecto != undefined) OnCorrecto(response);
      },
      OnErroneo,
      OnFinalizado
    );
  },
  /**
   * Agrega un comentario a una solicitud
   * @param {*} Vista 
   * @param {*} ID Identificador de la solicitud
   * @param {*} Datos {comentario: "El Comentario Comentario"}
   * @param {*} OnCorrecto 
   * @param {*} OnErroneo 
   * @param {*} OnFinalizado 
   * @returns 
   */
  postComentario(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Comentarios`);
    return Base.post(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  put(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  post(Vista, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.postBaseSuscripcion(
      Vista,
      BaseURL,
      Datos,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  get(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  /**
   * Respuesta detallada para visualización y análisis de contexto de una solicitud.
   * @typedef {Object} SolicitudAvanzadaData
   * @property {Object} solicitud - Datos de la solicitud solicitada.
   * @property {string} solicitud.id - ID de la solicitud (ej. "So.01...").
   * @property {string} solicitud.tipoSolicitud - Tipo de la solicitud (ej. "TiempoXTiempo", "Vacaciones", "TipoIncidencia").
   * @property {string} solicitud.estadoSolicitud - Estado actual (ej. "Desconocido", "Pendiente", "Autorizada", "Denegada").
   * @property {string} solicitud.colaboradorID - ID del colaborador dueño de la solicitud.
   * @property {boolean} solicitud.finalizada - Verdadero si la solicitud finalizó todas sus fases de flujo.
   * @property {Array<string>} solicitud.dias - Fechas involucradas en la solicitud.
   * @property {Array<Object>} solicitud.respuestas - Arreglo con la firma de respuesta de la solicitud (`id`, `fechaHora`, `acepto`, `comentario`).
   * @property {Object|null} cargaTipoIncidencia - Datos adicionales de validación si es TipoIncidencia.
   * @property {Object|null} cargaTiempoExtra - Payload extra si la solicitud es TiempoXTiempo.
   * @property {Object} cargaTiempoExtra.datos - Configuraciones de tiempo extra como `aplicarA` y `regresarDetalle`.
   * @property {Object} cargaTiempoExtra.config - Límites e intervalos para cálculo o proyección interna de horas adicionales.
   * @property {Object|null} cargaCargo - Información respectiva en flujos de nómina (Cargos).
   * @property {Object|null} cargaAumento - Información respectiva de recursos en flujos (Aumentos de Salario).
   * @property {Object} gestion - Detalles de los flujos preconfigurados aplicables a esta gestión.
   * @property {Object} gestion.flujoAsistencias - Parámetros de roles y número de firmas obligatorias.
   * @property {Object} flujo - El estado dinámico de autorizaciones escalonadas (flujo multinivel).
   * @property {boolean} flujo.tieneFlujo - Indica si está configurado en un workflow.
   * @property {boolean} flujo.flujoCompletado - Verdadero si se han otorgado todas las autorizaciones o fue negado ya en definitivo.
   * @property {number} flujo.totalNiveles - Número total de áreas o instancias de autorización, usualmente de 1 a 3.
   * @property {number} flujo.nivelActualIndice - Indica en qué nivel de firma del flujo se ha detenido para autorizar.
   * @property {Array<{indice: number, autorizacionesRequeridas: number, completado: boolean, autorizadores: Array<Object>}>} flujo.niveles - Cada nivel escalonado del motor de fluoj.
   * @property {Array<{colaboradorID: string, estado: string, comentario: string, esSiguienteTurno: boolean}>} flujo.niveles.autorizadores - Propiedades de cada aprobador (`estado` puede ser "Pendiente" o "Espera").
   * @property {Object|null} tipoIncidencia - Objeto origen del catálogo de incidencias referenciado si aplica a justificación.
   * @property {Array<{fecha: string, tipoDiario: string, esFalta: boolean, incompleto: boolean, turnoID: string}>} diarios - Asistencias u omisiones del usuario durante los días que abarca la solicitud.
   * @property {Array<Object>} diasFestivos - Días de asueto o festivos en el rango.
   * @property {Array<{lDias: Array<Object>, color: string, etiqueta: string, preguntaActivo: Object}>} turnos - Catálogo de los modelos de turnos vigentes del colaborador en estos días.
   * @property {Object|null} periodoNomina - Información del periodo fiscal vigente si se cruzara.
   * @property {Array<Object>} solicitudesPendientesColaborador - Histórico de las otras solicitudes activas de este recurso, previendo si hay posibles repeticiones o empalmes.
   * @property {Array<Object>} solicitudesEquipoPeriodo - Histórico de las solicitudes que hicieron otras personas de su mismo equipo (para evitar vaciar puestos u operaciones).
   * @property {number|null} saldoVacaciones - Saldo (En periodos o días netos) que cuenta el empleado a favor de vacaciones.
   * @property {number} txTSaldo - Contenedor base de su Tiempo por Tiempo.
   * @property {number} txTSaldoReal - Saldo TxT Real ya generado o autorizado del trabajador.
   * @property {Object} horasExtrasSemana - Estructura que evalúa si un colaborador rebasó márgenes legales (SueldosTriples) de forma semanalizada.
   * @property {Array<{fecha: string, horasExtras: Object}>} horasExtrasSemana.dias - Días de la semana reportados con sobre-ejecución vs su horario base.
   * @property {Object} estadisticasEquipo - KPIs y contadores gerenciales sumados de los colaboradores.
   * @property {number} estadisticasEquipo.totalSolicitudesPendientes - Cuántos asuntos restan en bandeja del área.
   * @property {number} estadisticasEquipo.txTPendientesMinutos - Estimación base de la deuda en tiempo.
   * @property {Array<{tipoSolicitud: string, pendientes: number, minAutorizados: number}>} estadisticasEquipo.solicitudesPorTipo - Sub-conteo de requerimientos analizado.
   * @property {Array<{id: string, etiqueta: string, urlMiniatura: string, esSolicitante: boolean, departamento: string, puesto: string}>} colaboradores - Directorio o de caché donde pueden buscarse los perfiles del solicitante y aprobadores para mostrar su avatar/puesto sin llamadas extras a API.
   */

  /**
   * Obtiene la información detallada de una solicitud y todo el contexto necesario para autorizarla o denegarla.
   * Ideal para ser utilizada en pantallas de detalle de la solicitud (BandejaFriccionDetalle, etc.).
   * 
   * @param {Object} Vista - Referencia a la vista actual de Vue (ej. `this`).
   * @param {string} id - Identificador de la solicitud que se está abriendo (ej. So.01.XYZ...).
   * @param {function({data: SolicitudAvanzadaData}): void} OnCorrecto - Callback llamado cuando la respuesta es exitosa. La información de respuesta estará parseada según las propiedades descritas en `data`.
   * @param {function(Object): void} [OnErroneo] - Callback de manejo alterno ante error HTTP, o negativa del middleware.
   * @param {function(): void} [OnFinalizado] - Callback final que siempre se ejecuta al cerrar la promesa del servicio o petición de UI, exitosa o con excepción.
   * @returns {Promise} Una promesa del motor de solicitudes web.
   */
  getAvanzado(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}/Avanzado`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  delete(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.deleteBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}`,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  EsPendiente(Solicitud) {
    return Solicitud.estadoSolicitud != "Autorizada" && Solicitud.estadoSolicitud != "Denegada";
  },
  GetsExcel(
    Vista,
    BaseGetsListado,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel`);

    return Base.get(
      Vista,
      URL,
      { responseType: "blob", params: BaseGetsListado },
      (response) => {
        Base.Response2FileDownload(response);
      },
      OnErroneo,
      OnFinalizado
    );
  },
};
